var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAttachment = function SvgAttachment(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C9.04 0 11.5 2.46 11.5 5.5L11.5 16C11.5 18.21 9.71 20 7.5 20C5.29 20 3.5 18.21 3.5 16V7.5C3.5 6.12 4.62 5 6 5C7.38 5 8.5 6.12 8.5 7.5V15H6.5V7.41C6.5 6.86 5.5 6.86 5.5 7.41V16C5.5 17.1 6.4 18 7.5 18C8.6 18 9.5 17.1 9.5 16V5.5C9.5 3.57 7.93 2 6 2C4.07 2 2.5 3.57 2.5 5.5L2.5 15H0.5L0.5 5.5C0.5 2.46 2.96 0 6 0Z",
    fill: "var(--iconColor, currentColor)"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAttachment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "attachment.6ebdfee7e9313f38878008d0ad7b3004.svg";